import { createSelector } from 'reselect'

import { CartModalState } from '../reducers/cart-modal.reducers'
import { SharedState } from '../sharedState'

const cartModal = (state: SharedState): CartModalState => state.cartModal

const isOpen = createSelector([cartModal], state => state.isOpen)
const product = createSelector([cartModal], state => state.product)
const type = createSelector([cartModal], state => state.type)

export const CartModalSelector = {
  cartModal,
  isOpen,
  product,
  type,
}
